{
  "chapel": {
    "id": "chapel-nave",
    "u": -18,
    "v": -6,
    "angleDeg": 0,
    "length": 43,
    "width": 10,
    "eaves": 12,
    "ridge": 17.8,
    "floors": 1,
    "bays": 7,
    "roof": "slate",
    "passage": 0
  },
  "belfry": {
    "u": -2,
    "radius": 0.65,
    "foot": 17.35,
    "eaves": 20,
    "tip": 23.4
  },
  "sideWing": {
    "u0": -39.5,
    "u1": 3.5,
    "v0": -1,
    "v1": 3.5,
    "eaves": 4.7,
    "high": 7.2,
    "bays": 7
  },
  "ranges": [
    {
      "id": "achterburgwal-main-body",
      "u": -43,
      "v": 7.5,
      "angleDeg": 81.2,
      "length": 36,
      "width": 8,
      "eaves": 9.6,
      "ridge": 14.4,
      "floors": 3,
      "bays": 9,
      "roof": "slate",
      "passage": 2.8,
      "roofGables": {
        "centres": [-9, 0, 9],
        "halfWidth": 1,
        "v0": 2,
        "v1": 4,
        "eaves": 12.1,
        "ridge": 13.4,
        "sill": 10.1,
        "top": 11.2
      }
    },
    {
      "id": "eastern-rear-body",
      "u": 46,
      "v": 6,
      "angleDeg": 86,
      "length": 32,
      "width": 7,
      "eaves": 7,
      "ridge": 11.5,
      "floors": 2,
      "bays": 8,
      "roof": "slate",
      "passage": 0
    },
    {
      "id": "north-low-range",
      "u": 5,
      "v": 25,
      "angleDeg": 0,
      "length": 75,
      "width": 4,
      "eaves": 4.2,
      "ridge": 6.9,
      "floors": 1,
      "bays": 15,
      "roof": "tile",
      "passage": 0
    }
  ],
  "rentals": [
    {
      "id": "rusland-corner",
      "u": -50,
      "v": -21.5,
      "angleDeg": 90,
      "length": 13,
      "width": 6,
      "eaves": 6.2,
      "ridge": 10.1,
      "floors": 2,
      "bays": 3,
      "roof": "tile",
      "passage": 0,
      "blindSides": [0, 1, 2],
      "doorSide": 3
    },
    {
      "id": "rusland-3-predecessor",
      "u": -44,
      "v": -21.5,
      "angleDeg": 90,
      "length": 13,
      "width": 6,
      "eaves": 7,
      "ridge": 11.2,
      "floors": 2,
      "bays": 3,
      "roof": "tile",
      "passage": 0,
      "blindSides": [0, 1, 2],
      "doorSide": 3
    },
    {
      "id": "rusland-5-predecessor",
      "u": -38,
      "v": -21.5,
      "angleDeg": 90,
      "length": 13,
      "width": 6,
      "eaves": 6.6,
      "ridge": 10.7,
      "floors": 2,
      "bays": 3,
      "roof": "tile",
      "passage": 0,
      "blindSides": [0, 1, 2],
      "doorSide": 3
    },
    {
      "id": "huidenkopers-guildhouse",
      "u": -30.5,
      "v": -21.5,
      "angleDeg": 90,
      "length": 13,
      "width": 9,
      "eaves": 8.2,
      "ridge": 13.7,
      "floors": 2,
      "bays": 4,
      "roof": "tile",
      "passage": 0,
      "blindSides": [0, 1, 2],
      "doorSide": 3
    }
  ],
  "court": [
    [-39.3, 3.6],
    [41.5, 3.6],
    [41.5, 22.9],
    [-34, 22.9]
  ],
  "garden": {
    "u0": -26,
    "u1": 36,
    "v0": 7,
    "v1": 21,
    "rows": 2,
    "columns": 5
  },
  "entryRange": "achterburgwal-main-body",
  "note": "The painting and 1544 woodcut guide the tall cross-plot nave, its lower parallel wing, high Achterburgwal body with roof gablets, separate eastern body, low northern range and open cultivated court. The current-address-related Rusland 1/3/5/7 bodies preserve documented rental use and the guildhouse owned since 1485; their number, vanished divisions, widths, depths and elevations are provisional, not a counted or excavated 1538 row. Their convent-facing rear walls and party walls have no openings. The later Spinhuis facade, Renaissance guild portal and 18th-century Rusland 3 facade are excluded. All component dimensions, the provisional three gablets, belfry, garden beds and west passage remain fitted estimates. Unread southern and eastern ground is reserved but left unfilled; the documented dividing ditch toward Paulus still needs a separate trace and bank-crossing reconstruction."
}
